export default {
    title: 'Löschen',
    deleteAction: 'Keinen Nutzer löschen | {count} Nutzer löschen | {count} Nutzer löschen',
    usersNotDeletable: 'Die Auswahl enthält Nutzer, die du nicht löschen kannst, da sie eine Rolle besitzen, die du nicht bearbeiten darfst.',
    reallyDelete: 'Möchtest du die ausgewählten Nutzer wirklich löschen?',
    reallyDeleteDeletableUsers: 'Möchtest du die ausgewählten Nutzer wirklich löschen? Die nicht löschbaren Nutzer werden übersprungen.',
    deletedUsers: 'Die Nutzer wurden gelöscht.'
}